import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

/**
 * Generated class for the EditTextPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */


@Component({
  selector: 'page-edit-text',
  templateUrl: 'edit-text.html',
})
export class EditTextPage {

  labelOnText: 'View name';
  editText: string;
  constructor(public viewCtrl: ViewController, public navParams: NavParams) {
    this.labelOnText = this.navParams.data.label;
    this.editText = this.navParams.data.value;
  }

  close() {
    console.log('Popup close');
    this.viewCtrl.dismiss(this.editText);
  }

}



// WEBPACK FOOTER //
// ./src/pages/edit-text/edit-text.ts